// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EiFEJn","messages":"_2p8_q3","maturityLockMessage":"_1I9CL5","icon":"_3gg5nm","logo":"_1GFTRr","acceptedPreorder":"_38ptLE","logoMessage":"_2bPNOP"};